import React from 'react';
import { PLATFORMS } from '../utils/constants';
import './SegmentedControl.css';

const SegmentedControl = ({ activeFilter, onFilterChange }) => {

  const handleFilterClick = (platform) => {
    onFilterChange(platform);
  };

  return (
    <div className="segmented-control-container">
      <div className="segmented-control">
        {PLATFORMS.map((platform) => (
          <button
            key={platform}
            className={`segment ${activeFilter === platform ? 'active' : ''}`}
            onClick={() => handleFilterClick(platform)}
          >
            {platform}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SegmentedControl;